import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-row-card',
  templateUrl: './row-card.component.html',
  styleUrls: ['./row-card.component.scss']
})
export class RowCardComponent {
  @Input() title: string;
  @Input() subTitle: string;
  @Input() photoUrl: string;
  @Input() index: number;
  @Input() isDeactivated = false;
  @Input() showPhoto = true;
  @Output() editButtonEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() detailsEvent: EventEmitter<void> = new EventEmitter<void>();
}
